import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../layout/header";
import Footer from "../layout/footer";

const bg = require("../../images/servicehero.png");

class CarpetCleaning extends Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">Carpet Steam Cleaning </h1>
                <div className="breadcrumb-row">
                  {/* <ul className="list-inline">
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>Service</li>
                    <li>Service Details</li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-5">
                    <div className="widget sidebar-widget ext-sidebar-menu widget_nav_menu">
                      <ul className="menu">
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/airbnb-cleaning"
                          >
                            Airbnb Property Management
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/residential-cleaning"
                          >
                            Residential Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/office-cleaning"
                          >
                            Office Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/school-and-medical-cleaning"
                          >
                            School And Medical Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/bond-cleaning"
                          >
                            Bond Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/window-cleaning"
                          >
                            Window Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/special-event-cleaning"
                          >
                            Special Event Cleaning
                          </Link>{" "}
                        </li>
                        <li className="active">
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/carpet-steam-cleaning"
                          >
                            Carpet Steam Cleaning
                          </Link>{" "}
                        </li>
                        <li>
                          <Link
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: "auto"
                              });
                            }}
                            to="/spring-cleaning"
                          >
                            Spring Cleaning
                          </Link>{" "}
                        </li>
                      </ul>
                    </div>
                    {/* <div className="widget">
                      <div className="download-file">
                        <h4 className="title">Get your brochures</h4>
                        <ul>
                          <li>
                            <Link to="#" target="_blank">
                              <div className="text">Company Brochures</div>
                              <i className="fa fa-download"></i>
                            </Link>
                          </li>
                          <li>
                            <Link to="#" target="_blank">
                              <div className="text">Company Info</div>
                              <i className="fa fa-download"></i>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div> */}
                  </div>
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className=" col-md-12 m-b30">
                      <div className="dlab-box">
                        {/* <div className="dlab-media">
                            {" "}
                            <Link to="#">
                              <img
                                src={require("../../images/about/pic4.jpg")}
                                alt=""
                              />
                            </Link>{" "}
                          </div> */}
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              Professional Carpet Steam Cleaning in Gold Coast
                              Can Help You Keep Your Carpets Free of Allergens
                              to Ensure a Healthier Environment.
                            </Link>
                          </h4>
                          <p>
                            The carpet in your home experiences more daily wear
                            and tear than any other item. Every six to twelve
                            months, your carpet must be cleaned to keep
                            allergies and filth at bay. In addition to extending
                            the life of your carpet, proper care and upkeep will
                            make your home healthier for your family.
                            Professional carpet cleaning businesses offer
                            thorough cleaning, sanitizing, and deodorizing
                            services to protect your carpet from allergens,
                          </p>
                        </div>
                        <div className="dlab-info m-t30 ">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              How long does carpet steam cleaning take to dry a
                              carpet?
                            </Link>
                          </h4>
                          <p>
                            After cleaning, your carpet will feel hardly damp to
                            the touch. Usually, it takes 6 to 10 hours for
                            carpets to completely dry. Nevertheless, depending
                            on the time of year your carpets are cleaned, as
                            well as the air circulation, humidity, and indoor
                            temperature, it could take up to 24 hours to dry. In
                            the summer, air conditioning will be more effective
                            than heat since it can take moisture out of the air.
                            It also helps to open windows and doors to let more
                            air in.
                          </p>
                        </div>
                        <div className="dlab-info m-t30 ">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              Carpet Steam Cleaning VS Dry Carpet Cleaning
                            </Link>
                          </h4>
                          <p>
                            The best carpet cleaning procedure is hot water
                            extraction or carpet steam cleaning, which poses the
                            fewest health risks to you and your loved ones. The
                            process usually takes around 20 minutes for a
                            standard room. It depends on the level of soiling,
                            furniture removal, staining, etc. In contrast, the
                            other widely used method, "Dry Cleaning," uses
                            intense chemicals or solvents to break down soil on
                            top of the carpets.
                          </p>
                          <p>
                            Even after being cleaned away, these substances
                            still leave a sticky residue that draws dirt back to
                            the carpet's surface and causes it to become dirty
                            once more. Many people with respiratory or skin
                            allergies also respond poorly to these harsh
                            chemical residues. Carpet steam cleaning completely
                            flushes out pollutants and cleaning chemicals,
                            leaving them odor- and allergen-free.
                          </p>
                        </div>
                        <div className="dlab-info m-t30 ">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              How To Prepare Before a Carpet Steam Cleaning?
                            </Link>
                          </h4>
                          <p>
                            It is advised to vacuum your carpet regularly to
                            prevent sand or filth from sticking to the carpet
                            fibers. Even if it is invisible to the naked eye,
                            these granules can create excessive wear on the
                            fibers as you walk across them. It eventually
                            results in carpet damage. So make sure to vacuum
                            your carpet frequently, ideally once or twice every
                            week.
                          </p>
                          <p>
                            Customers should put away toys, shoes, and other
                            objects before arrival. It is advised to vacuum to
                            remove any pet hair or other debris if present
                            because professional vacuum cleaners are made to
                            extract liquids and soils. Any breakable objects,
                            such as picture frames or decorations, can be safely
                            removed from the area for the time being.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="dlab-box">
                      <div className="dlab-info m-t30">
                        <h4 className="dlab-title m-t0">
                          <Link to="#">
                            Why Hire a Professional Carpet Steam Cleaning
                            Service in Gold Coast?
                          </Link>
                        </h4>
                        <p>
                          Specialized carpet steam cleaning companies use the
                          best equipment to provide the best outcomes.
                          Professional carpet cleaning equipment produces higher
                          pressure, heat, and vacuum. Different fibers and
                          synthetic materials necessitate expert assistance to
                          prolong the life of your carpet while thoroughly
                          cleaning it.
                        </p>
                        <p>
                          A hire/rent or buy option is far from competitive with
                          the extraction power and cleaning water heat.
                          Professional methods can eliminate dust mites and
                          microorganisms resistant to commercial cleaning
                          equipment. Professional cleaners who are qualified and
                          experienced can get rid of stains and preserve the
                          integrity of your carpet for years to come. After
                          cleaning, wastewater disposal is more effective,
                          removing any potential mold problems.
                        </p>
                        <p>
                          Invest in improving the appearance and durability of
                          your carpets with the help of a professional carpet
                          steam cleaning service in Gold Coast, Queensland. We
                          at Gold Coast Kangaroo Shine Property Services in Gold
                          Coast provide quality carpet steam cleaning with
                          premium cleaning equipment. Generally, professional
                          carpet cleaning should take place at least once a
                          year. However, it can depend on how frequently the
                          sites are occupied.
                        </p>
                        <p>
                          If you are located around Gold Coast, Queensland, and
                          are searching for a professional carpet cleaning
                          service, call us at +61424888804 to request a free
                          quote and schedule your inspection today.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}
export default CarpetCleaning;
